/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberFieldTypes } from './WebApiModelsEnumerationTypesMemberFieldTypes';
import {
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSON,
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSONTyped,
    WebApiModelsEnumerationTypesMemberFieldTypesToJSON,
} from './WebApiModelsEnumerationTypesMemberFieldTypes';
import type { WebApiModelsEnumerationTypesUiControl } from './WebApiModelsEnumerationTypesUiControl';
import {
    WebApiModelsEnumerationTypesUiControlFromJSON,
    WebApiModelsEnumerationTypesUiControlFromJSONTyped,
    WebApiModelsEnumerationTypesUiControlToJSON,
} from './WebApiModelsEnumerationTypesUiControl';

/**
 * 
 * @export
 * @interface WebApiMemberFieldsDtoMemberUploadFieldDto
 */
export interface WebApiMemberFieldsDtoMemberUploadFieldDto {
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberFieldTypes}
     * @memberof WebApiMemberFieldsDtoMemberUploadFieldDto
     */
    fieldType?: WebApiModelsEnumerationTypesMemberFieldTypes;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberFieldsDtoMemberUploadFieldDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberFieldsDtoMemberUploadFieldDto
     */
    customFieldName?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesUiControl}
     * @memberof WebApiMemberFieldsDtoMemberUploadFieldDto
     */
    uiControl?: WebApiModelsEnumerationTypesUiControl;
}

/**
 * Check if a given object implements the WebApiMemberFieldsDtoMemberUploadFieldDto interface.
 */
export function instanceOfWebApiMemberFieldsDtoMemberUploadFieldDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberFieldsDtoMemberUploadFieldDtoFromJSON(json: any): WebApiMemberFieldsDtoMemberUploadFieldDto {
    return WebApiMemberFieldsDtoMemberUploadFieldDtoFromJSONTyped(json, false);
}

export function WebApiMemberFieldsDtoMemberUploadFieldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberFieldsDtoMemberUploadFieldDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldType': !exists(json, 'fieldType') ? undefined : WebApiModelsEnumerationTypesMemberFieldTypesFromJSON(json['fieldType']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'customFieldName': !exists(json, 'customFieldName') ? undefined : json['customFieldName'],
        'uiControl': !exists(json, 'uiControl') ? undefined : WebApiModelsEnumerationTypesUiControlFromJSON(json['uiControl']),
    };
}

export function WebApiMemberFieldsDtoMemberUploadFieldDtoToJSON(value?: WebApiMemberFieldsDtoMemberUploadFieldDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldType': WebApiModelsEnumerationTypesMemberFieldTypesToJSON(value.fieldType),
        'id': value.id,
        'customFieldName': value.customFieldName,
        'uiControl': WebApiModelsEnumerationTypesUiControlToJSON(value.uiControl),
    };
}

